import React from "react";
import { observer } from "mobx-react-lite";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { getCurrentCulture } from "@utils";
import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import BetBuilderPicksQuotaButton from "../BetBuilderPicksQuotaButton";
import { analyticsTracker } from "@utils/analytics";
import { BetBuilderPicksStore } from "@state/quick-play-store/BetBuilderPicksStore";
import { ChangePageButton } from "@state/quick-play-store/MostPlayedTicketsStore";
import { QuickPlayPaginationButton } from "@features/quick-play/desktop/common/QuickPlayPaginationButton";

export default observer(function BetBuilderPicksPopupFooter(props: {
	slip: BetBuilderPick;
	store: BetBuilderPicksStore;
}) {
	const t = useTranslation().t;
	const location = useLocation();

	const isOnQuickPlayPage = location.pathname.includes("quick-play");
	const isPrevAndNextDisabled = props.store.currentActiveList.size == 1;

	return (
		<div className="popup__footer popup__footer--bordered">
			<div className="popup__footer__left">
				{!isOnQuickPlayPage && (
					<Link
						to={`/${getCurrentCulture()}/quick-play/bet-builder-picks`}
						className="popup--most__btn popup--most__btn--secondary btn btn--med btn--primary--inverted"
					>
						<span className="btn__label">
							{t("COMMON.SHOW_MORE")}
						</span>
					</Link>
				)}
			</div>

			<div className="popup__footer__inner popup__footer__inner--right">
				<QuickPlayPaginationButton
					direction="prev"
					onClick={() => {
						props.store.changePage(ChangePageButton.PREVIOUS);
						analyticsTracker.trackModalSwitcher("bb-picks");
					}}
					disabled={isPrevAndNextDisabled}
					label={t("COMMON.PREVIOUS_BUTTON")}
				/>
				<BetBuilderPicksQuotaButton
					BBPick={props.slip}
					isInPopup
					store={props.store}
				/>
				<QuickPlayPaginationButton
					direction="next"
					onClick={() => {
						props.store.changePage(ChangePageButton.NEXT);
						analyticsTracker.trackModalSwitcher("bb-picks");
					}}
					disabled={isPrevAndNextDisabled}
					label={t("COMMON.NEXT_BUTTON")}
				/>
			</div>
		</div>
	);
});
